import { render, staticRenderFns } from "./UserLists.vue?vue&type=template&id=855d7dcc&scoped=true"
import script from "./UserLists.vue?vue&type=script&lang=js"
export * from "./UserLists.vue?vue&type=script&lang=js"
import style0 from "./UserLists.vue?vue&type=style&index=0&id=855d7dcc&prod&lang=scss&scoped=true"
import style1 from "./UserLists.vue?vue&type=style&index=1&id=855d7dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855d7dcc",
  null
  
)

export default component.exports